import VN from "../components/VN";
import { useContext, useState, useEffect } from "react";
import { UserDataContext } from "../components/UserDataContext";
import { Container, Table } from "react-bootstrap";
import { apiRequest } from "../components/Config";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import { TextField } from "@mui/material";
import Alerts from "../components/Alerts";
import { Row } from "react-bootstrap";
import { marginBottom } from "../App";

export default function DocTypes() {
  const { userData } = useContext(UserDataContext);
  const [docType, setDocType] = useState([]);
  const [newDocType, setNewDocType] = useState("");
  const [showAddDocType, setShowAddDocType] = useState(false);
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);
  useEffect(() => {
    if (userData) {
      fetchData();
    }
  }, [userData]);

  const handleShowAddDocType = () => {
    setShowAddDocType(!showAddDocType);
  };

  const fetchData = async () => {
    try {
      const response = await apiRequest("filestypes", "GET");
      //console.log("Projects: ", response);
      if (Array.isArray(response)) {
        setDocType(response);
      } else {
        setDocType([]);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const values = {};
  const handleAddDocType = async (newDocType) => {
    values["doctype"] = newDocType;
    setNewDocType(newDocType);
    console.log("New types: ", values);
    try {
      const response = await apiRequest(`insertdoctype`, "POST", values);
      console.log("response type: ", response);
      if (response.error_msg === 200) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Informacja",
          severity: "success",
          info: "Nowy typ dokumentu dodany!",
        });
        await fetchData();
      }
      if (response.error_msg === 502) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Informacja",
          severity: "error",
          info: "Ten typ dokumentu już istnieje!",
        });
      }
      if (response.error_msg === 503) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Informacja",
          severity: "warning",
          info: "Nie wprowadzono nazwy projektu...",
        });
      }
    } catch (error) {
      setShowApiResponse(true);
      setApiResponse({
        title: "Uwaga",
        severity: "error",
        info: "Nie udało się zaktualizować!",
      });
      console.error("There was an error editing the user!", error);
    }
  };
  return (
    <div>
      <VN userData={userData} />
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <h1>Typy dokumentów</h1>
      <Container>
        <div className="table-responsive">
          <Table bordered hover>
            <thead>
              <tr>
                <th className="td-centered">ID</th>
                <th className="td-centered">Typ</th>
                <th className="td-centered">Aktywny</th>
              </tr>
            </thead>
            <tbody>
              {docType.map((docTypes, index) => (
                <tr key={docTypes.id}>
                  <td className="td-centered">{index + 1}</td>
                  <td>{docTypes.type}</td>
                  <td className="td-centered">
                    {docTypes.active ? "✅" : "❌"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <Button onClick={handleShowAddDocType}>
          Dodaj typ dokumentu
          <AddIcon />
        </Button>
        {showAddDocType && (
          <>
            <h6>Dodanie nowego projektu</h6>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleAddDocType(newDocType);
                setNewDocType("");
              }}
            >
              <TextField
                name="type"
                label="Nowy typ dokumentu"
                variant="outlined"
                value={newDocType}
                onChange={(e) => setNewDocType(e.target.value)}
                fullWidth
              />
              <Button type="submit">Zapisz</Button>
            </form>
          </>
        )}
      </Container>
    </div>
  );
}
